var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChat = function SvgChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 20",
    width: 14,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39585 1.28028C6.3563 1.27878 5.33528 1.55551 4.43876 2.08175C3.54224 2.60799 2.80288 3.36456 2.29741 4.27295C1.79194 5.18135 1.53878 6.20846 1.5642 7.24771C1.58962 8.28695 1.89269 9.30046 2.44196 10.1831L0.729187 13.7803L4.32585 12.0675C5.09291 12.5444 5.96024 12.8367 6.85949 12.9213C7.75875 13.0059 8.66537 12.8805 9.50792 12.555C10.3505 12.2296 11.1059 11.7129 11.7148 11.0457C12.3236 10.3785 12.7692 9.57908 13.0164 8.71034C13.2637 7.84161 13.3058 6.92734 13.1395 6.03955C12.9732 5.15176 12.603 4.31473 12.0581 3.59438C11.5132 2.87404 10.8084 2.29008 9.99938 1.88851C9.19033 1.48694 8.29908 1.27873 7.39585 1.28028Z",
    fill: "none",
    stroke: "#1890FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.07259728b98dcaec79e7ec8e42ccbc74.svg";